import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PopoverDirective } from 'ngx-bootstrap';

/**
 * A wrapper component for showing a confirm dialog when the provided ng-content is clicked.
 *
 * Example usage:
 * <ssf-confirm-dialog (onConfirm)="test($event)" headerTitle="{{ 'TRANSLATE-PATH' | translate }}">
 *   <ssf-button btnText="Trigger button"></ssf-button>
 * </ssf-confirm-dialog>
 */
@Component({
    selector: 'ssf-confirm-dialog',
    template: require('./confirm-dialog.component.html'),
    styles: [require('./confirm-dialog.component.scss')]
})
export class ConfirmDialogComponent {
    /**
     * A translation string pointing to a title placed in a a header. Title is typically similar to a question like
     * "Really delete this....?", that can be answered "yes" or "no".
     */
    @Input() headerTitle: string;
    /**
     * Whether a popover should be forbidden to appear.
     */
    @Input() popDisabled: boolean;
    /**
     * Fired when action is confirmed through the inner confirm button.
     */
    @Output() onConfirm = new EventEmitter<any>();
    /**
     * Translation path prefix for this component.
     */
    public i18n = 'SHARED.CONFIRM-DIALOG.';

    confirm(elem: PopoverDirective) {
        elem.hide();
        this.onConfirm.emit(null);
    }

    cancel(elem: PopoverDirective) {
        elem.hide();
    }

    trigger(elem: PopoverDirective) {
        if (!this.popDisabled) {
            elem.toggle();
        }

        // v pripade, ze je jako wrapovana komponenta switch-button, nechci switch button hned prepnout, ale az na
        // kliknuti na potvrzovaci button; return false zajisti, ze se switch buton hned neprepne
        return false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/confirm-dialog/confirm-dialog.component.ts